(function() {
  'use strict';

  angular.module('app.parcels')
    .directive('generalBulkEdit', generalBulkEdit);

  /** @ngInject */
  function generalBulkEdit($templateCache) {
    return {
      restrict: 'E',
      scope: {
        checkeditems: '=',
        fields: '='
      },
      controller: 'GeneralBulkEditCtrl',
      controllerAs: 'vm',
      bindToController: true, // because the scope is isolated
      template: $templateCache.get('modules/generalBulkEdit/generalBulkEdit.html')
    };
  }
})();
